export const linkCode = {
    curl: {
        request: `curl -X 'POST' 
'https://demo-api.westpay.se/in-store/api/v1/terminal/link'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-H'Content-Type: application/json'
-d'{
    "terminalId": "80000456",
    "registrationCode": "064767"
}'`
    },
    java: {
        request: `import com.fasterxml.jackson.databind.ObjectMapper;
import java.io.BufferedReader;
import java.io.IOException;
import java.io.InputStreamReader;
import java.io.OutputStream;
import java.net.HttpURLConnection;
import java.net.URL;
      
public class TerminalLinkingExample {
    public static void main(String[] args) {
        try {
            URL url = new URL("https://demo-api.westpay.se/in-store/api/v1/terminal/link");
            HttpURLConnection connection = (HttpURLConnection) url.openConnection();
            connection.setRequestMethod("POST");
            connection.setRequestProperty("accept", "text/plain");
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", "76591d32138f4f60b580db9ec9167f1d");
            connection.setRequestProperty("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco");
            connection.setRequestProperty("Content-Type", "application/json");
            connection.setDoOutput(true);
      
            // Create the request body object
            TerminalLinkRequest requestBody = new TerminalLinkRequest("80000456", "064767");
      
            // Serialize the request body object to JSON
            ObjectMapper objectMapper = new ObjectMapper();
            String jsonBody = objectMapper.writeValueAsString(requestBody);
      
            // Write the JSON body to the request
            OutputStream outputStream = connection.getOutputStream();
            outputStream.write(jsonBody.getBytes());
            outputStream.close();
      
            int responseCode = connection.getResponseCode();
            if (responseCode == HttpURLConnection.HTTP_OK) {
                BufferedReader reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
                String line;
                StringBuilder response = new StringBuilder();
      
                while ((line = reader.readLine()) != null) {
                    response.append(line);
                }
      
                reader.close();
      
                System.out.println("Response: " + response.toString());
            } else {
                System.out.println("Request failed. Response Code: " + responseCode);
            }
      
            connection.disconnect();
        } catch (IOException e) {
            e.printStackTrace();
        }
    }
      
    // Class representing the terminal link request body
    private static class TerminalLinkRequest {
        private String terminalId;
        private String registrationCode;
      
        public TerminalLinkRequest(String terminalId, String registrationCode) {
            this.terminalId = terminalId;
            this.registrationCode = registrationCode;
        }
      
        // Getters and setters (if needed)
      
        public String getTerminalId() {
            return terminalId;
        }
      
        public void setTerminalId(String terminalId) {
            this.terminalId = terminalId;
        }
      
        public String getRegistrationCode() {
            return registrationCode;
        }
      
        public void setRegistrationCode(String registrationCode) {
            this.registrationCode = registrationCode;
        }
    }
}`
    },
    "C#": {
        request: `using System;
using System.IO;
using System.Net;
using System.Text;
using Newtonsoft.Json;
      
namespace TerminalLinkingExample
{
    class Program
    {
        static void Main(string[] args)
        {
            try
            {
                string url = "https://demo-api.westpay.se/in-store/api/v1/terminal/link";
                var request = (HttpWebRequest)WebRequest.Create(url);
                request.Method = "POST";
                request.Headers["accept"] = "text/plain";
                request.Headers["Ocp-Apim-Subscription-Key"] = "76591d32138f4f60b580db9ec9167f1d";
                request.Headers["Authorization"] = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco";
                request.ContentType = "application/json";
      
                // Create the request body object
                TerminalLinkRequest requestBody = new TerminalLinkRequest
                {
                    TerminalId = "80000456",
                    RegistrationCode = "064767"
                };
      
                // Serialize the request body object to JSON
                string jsonBody = JsonConvert.SerializeObject(requestBody);
      
                // Write the JSON body to the request
                byte[] requestBodyBytes = Encoding.UTF8.GetBytes(jsonBody);
                request.ContentLength = requestBodyBytes.Length;
                using (Stream requestStream = request.GetRequestStream())
                {
                    requestStream.Write(requestBodyBytes, 0, requestBodyBytes.Length);
                }
      
                using (HttpWebResponse response = (HttpWebResponse)request.GetResponse())
                {
                    if (response.StatusCode == HttpStatusCode.OK)
                    {
                        using (StreamReader reader = new StreamReader(response.GetResponseStream()))
                        {
                            string responseBody = reader.ReadToEnd();
                            Console.WriteLine("Response: " + responseBody);
                        }
                    }
                    else
                    {
                        Console.WriteLine("Request failed. Response Code: " + response.StatusCode);
                    }
                }
            }
            catch (WebException ex)
            {
                Console.WriteLine("An error occurred: " + ex.Message);
            }
        }
    }
      
    // Class representing the terminal link request body
    public class TerminalLinkRequest
    {
        [JsonProperty("terminalId")]
        public string TerminalId { get; set; }
      
        [JsonProperty("registrationCode")]
        public string RegistrationCode { get; set; }
    }
}`
    },
    python: {
        request: `url = 'https://demo-api.westpay.se/in-store/api/v1/terminal/link'
headers = {
    'accept': 'text/plain',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco',
    'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
    'Content-Type': 'application/json'
}

# Create the request body
request_body = {
    'terminalId': '80000456',
    'registrationCode': '064767'
}

# Convert the request body to JSON
json_data = json.dumps(request_body).encode('utf-8')

# Send the HTTP request
req = urllib.request.Request(url, data=json_data, headers=headers)
try:
    with urllib.request.urlopen(req) as response:
        if response.getcode() == 200:
            # Read the response
            response_data = response.read().decode('utf-8')
            print('Response:', response_data)
        else:
            print('Request failed. Response Code:', response.getcode())
except urllib.error.HTTPError as e:
    print('An error occurred:', e)`
    },
    JavaScript: {
        request: `const fetch = require('node-fetch');

const url = 'https://demo-api.westpay.se/in-store/api/v1/terminal/link';
const headers = {
  'accept': 'text/plain',
  'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco',
  'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
  'Content-Type': 'application/json'
};

// Create the request body
const requestBody = {
  terminalId: '80000456',
  registrationCode: '064767'
};

// Send the HTTP request
fetch(url, {
  method: 'POST',
  headers: headers,
  body: JSON.stringify(requestBody)
})
  .then(response => {
    if (response.ok) {
      return response.text();
    } else {
      throw new Error('Request failed. Response Code: ' + response.status);
    }
  })
  .then(responseData => {
    console.log('Response:', responseData);
  })
  .catch(error => {
    console.error('An error occurred:', error);
  });`
    }
};

export const linkCodeResponse = `{
  "printerEnabled": true
}`;
